export default __webpack_public_path__ + "static/media/4.32449c90.png";